import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { orderData } from "@/data/order-data";
import { TableVariantProps } from "rizzui";
import { OrdersDataType } from "../../ecommerce/dashboard/recent-order";
import { basicColumns } from "./column";

export default function BasicTable({
    stickyHeader = false,
    variants = "classic",
}: {
    stickyHeader?: boolean;
    variants?: TableVariantProps;
}) {
    const { table, setData } = useTanStackTable<OrdersDataType>({
        tableData: orderData,
        columnConfig: basicColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: stickyHeader ? orderData.length : 7,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <Table table={table} stickyHeader={stickyHeader} variant={variants} />
    );
}
